module.exports = function getResource(label, vars = []) {
    let resources = {
        seeAll: 'See all'
    };

    return resources[label];
};
